import styled from "styled-components"
import Btn from "../../shared/button/Btn";
import { showModal } from "../../../features/modal/modalSlice";
import { clearCheckedData, sendMail } from "../../../features/joblist/jobListSlice";
import { useDispatch } from "react-redux";
import SmallSpinner from "../../shared/spinners/SmallSpinner";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import TasimaSenediPDF from "../../pdf/TasımaSenediPDF";
import { pdf } from "@react-pdf/renderer";
import getCurrentDate from "../../../helper/getCurrentDate";
import { setLoadItemSelect } from "../../../features/loadList/loadListSlice";
import { useNavigate } from "react-router-dom";

const Container = styled.div`
    display: flex;
    gap: 40px;
    margin-top: 20px;


    .sended-type-item{
        display: flex;
        border: 2px solid var(--color-main);
        border-radius: 10px;
        overflow: hidden;

        input{
            width: 240px;
            padding: 5px 15px;
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            color: ${({theme}) => theme.mainTextColor};

        }
    }
`

const JobListMektupSender = () => {

    const dispatch = useDispatch()
    const [mailAdres, setMailAdres] = useState("");
    const [activeSendedType, setActiveSendedType] = useState(null);
    const { isLoadingSendMail, mektupData } = useSelector(state => state.jobList);
    const [blob, setBlob] = useState()
    const navigate = useNavigate()

    
    const sendWithMail = () => {
        if(blob && mailAdres){
            dispatch(sendMail({gunlukAracId: mektupData.aracData.id, file:blob, mail: mailAdres, yukId: mektupData.yukData.id, fileName: `Tasima-Senedi-${mektupData?.aracData?.truck?.plateNumber}-${getCurrentDate()}.pdf`}))
        }
    }


    useEffect(() => {
        const generatePDFBlob = async () => {
            try {
                // const blob = await pdf(<TasimaSenediPDF />).toBlob().then((blob) => saveAs(blob, "YourFileName.pdf"));
                const blob = await pdf(<TasimaSenediPDF data={mektupData} />).toBlob();
                //   saveAs(blob, "Asdas1234.pdf")
              setBlob(blob)
            } catch (error) {
              console.error("PDF oluşturulurken hata oluştu:", error);
              throw error;
            }
          };
          generatePDFBlob()
    },[])

  return (
    <Container>
    {/* <PDFDownloadLink document={<TasimaSenediPDF />} fileName="asdasasadasasa">
        {({ loading }) => (loading ? <button>loading doc</button> : <button>download</button>)}
    </PDFDownloadLink> */}
        {
            activeSendedType === "mail" ?
            <div className="sended-type-item">
                <input type="text" onChange={(e) => setMailAdres(e.target.value)} value={mailAdres} placeholder="Mail Adresi Girin"/>
                <Btn handleClick={() => {sendWithMail(); setActiveSendedType(null)}} color="#fff" width={"200px"} radius="0" bgColor="#E85546">Gönder</Btn>
            </div>
            : 
            <Btn handleClick={() => setActiveSendedType("mail")} color="#fff" width={"200px"} height="44px" bgColor="#E85546" >{isLoadingSendMail ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Mail ile Gönder"}</Btn>
        }
        <Btn handleClick={() => {dispatch(showModal(null)); dispatch(setLoadItemSelect(mektupData.yukData.id)); navigate("/yuklemede"); dispatch(clearCheckedData())}} color="#fff" width={"200px"} height="44px" bgColor="#E85546" >Kapat</Btn>
    </Container>
  )
}

export default JobListMektupSender